/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';

// This is only used for the taskDetail.jsx modal component
class Status extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    event.preventDefault();
    let field = {};
    const newStatus = event.target.name;
    if (newStatus === 'ready') {
      field = {
        started: false,
        completed: false
      };
    } else if (newStatus === 'inProgress') {
      field = {
        started: true,
        completed: false
      };
    } else if (newStatus === 'devComplete') {
      field = {
        completed: true
      };
    }
    this.props.onStatusChange(field);
  }

  render() {
    const started = this.props.started;
    const completed = this.props.completed;
    const disabled = !this.props.allowEdit;

    return (
      <div className="row">
        <div className="col-sm-4">
          <button
            name="ready"
            className={`status-btn ready-normal ${
              !started && !completed ? 'ready-active' : ''
            }`}
            onClick={this.handleClick}
            disabled={disabled || !this.props.task?.id}
          >
            READY
          </button>
        </div>
        <div className="col-sm-4">
          <button
            name="inProgress"
            className={`status-btn progress-normal ${
              started && !completed ? 'progress-active' : ''
            }`}
            onClick={this.handleClick}
            disabled={disabled || !this.props.task?.id}
          >
            IN PROGRESS
          </button>
        </div>
        <div className="col-sm-4">
          <button
            name="devComplete"
            className={`status-btn complete-normal ${
              completed ? 'complete-active' : ''
            }`}
            onClick={this.handleClick}
            disabled={disabled || !this.props.task?.id}
          >
            DEV COMPLETE
          </button>
        </div>
      </div>
    );
  }
}

Status.propTypes = {
  onStatusChange: PropTypes.func,
  completed: PropTypes.bool,
  started: PropTypes.bool,
  allowEdit: PropTypes.bool
};

export default Status;
